import {
  Button,
  LoadingIndicator,
  Switch,
  useToggle,
} from '@commenda/kakashi';
import { formatCurrency } from '@commenda/utils';
import { useBillingContext } from '../context/billingContext';
import { getTotalQuantity } from '../utils';

export const BillingSummary = () => {
  const {
    billingItems,
    subTotal,
    currency,
    onCheckout,
    shouldBillToClient,
    setShouldBillToClient,
    isAffiliateFirmUser,
  } = useBillingContext();
  const isSubmittingToggle = useToggle(false);
  return (
    <div className="w-full p-6 border border-border-primary rounded-xl">
      <div className="pb-4 border-b border-border-primary">
        <span className="txt-small-bold text-text-primary">Order Summary</span>
      </div>
      <div className="py-6 flex gap-4 justify-between border-b border-border-primary">
        <span className="txt-small-regular">
          Subtotal ({getTotalQuantity(billingItems)} items)
        </span>
        <span className="txt-small-bold">
          {formatCurrency({ price: subTotal, currency })}
        </span>
      </div>
      <div className="py-6 flex justify-between txt-extra-large-bold">
        <span>Total</span>
        <span>{formatCurrency({ price: subTotal, currency })}</span>
      </div>
      {isAffiliateFirmUser && (
        <div className="pb-6 flex items-center justify-between">
          <span className="txt-small-medium text-text-primary">
            Bill to client
          </span>
          <Switch
            checked={shouldBillToClient ?? true}
            onCheckedChange={(checked) => {
              setShouldBillToClient?.(checked);
            }}
          />
        </div>
      )}
      <Button
        size="xl"
        fullWidth
        onClick={async () => {
          isSubmittingToggle.on();
          const success = await onCheckout();
          if (!success) {
            isSubmittingToggle.off();
          }
        }}
        disabled={isSubmittingToggle.value}
      >
        {isSubmittingToggle.value ? (
          <div className="flex items-center gap-2">
            <LoadingIndicator />
            <span>Processing...</span>
          </div>
        ) : (
          'Checkout'
        )}
      </Button>
    </div>
  );
};
